// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__heefU","box":"style_box__lopNO","active":"style_active__OOMlK","title":"style_title__fLZ3q","item":"style_item__Wqm7w"};